import { chapterActionTypes as types } from 'src/redux/actions/chapterActions';

const initialState = {
  loading: false,
  error: null,
  chapters: {},
  darkMode: false,
  scrollHorizontal: false,
  fullWidth: false
};

export default function chapterReducer(state = initialState, { type, data, error, payload }) {
  switch (type) {
    case types.FETCH_CHAPTERS_REQUEST:
    case types.ADD_CHAPTER_REQUEST:
    case types.EDIT_CHAPTER_REQUEST:
    case types.DELETE_CHAPTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case types.FETCH_CHAPTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        chapters: data
      }
    case types.ADD_CHAPTER_SUCCESS:
    case types.EDIT_CHAPTER_SUCCESS:
    case types.DELETE_CHAPTER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      }
    case types.FETCH_CHAPTERS_FAILURE:
    case types.ADD_CHAPTER_FAILURE:
    case types.EDIT_CHAPTER_FAILURE:
    case types.DELETE_CHAPTER_FAILURE:
      return {
        ...state,
        loading: false,
        error
      }
    case types.TOGGLE_DARK_MODE:
      return {
        ...state,
        darkMode: payload
      }
    case types.TOGGLE_SCROLL_HORIZONTAL:
      return {
        ...state,
        scrollHorizontal: payload
      }
    case types.TOGGLE_FULL_WIDTH:
      return {
        ...state,
        fullWidth: payload
      }
    default:
      return state;
  }
}
